export default "__VITE_ASSET__05653d45__"